import React from 'react'
import { MovableModalContainer } from 'components/MovableModal'
import { useSelector } from 'react-redux'
import { selectShowReferenceFileChoice } from 'selectors/mainView'
import { useAction } from 'hooks'
import { showReferenceFileChoiceAction } from 'actions/mainView'
import { ReferenceFileChoiceComponent } from './ReferenceFileСhoiceComponent'

export const ReferenceFileChoiceContainer = () => {
  const visible = useSelector(selectShowReferenceFileChoice)
  const onCloseWindow = useAction(showReferenceFileChoiceAction, { visibility: false }) as () => void
  return (
    <MovableModalContainer
      visible={visible}
      restorePosition={false}
      width={493}
      height={268}
      onCloseWindow={onCloseWindow}
      withBackground
      windowId="ReferenceFileChoiceContainer"
    >
      <ReferenceFileChoiceComponent visible={visible} />
    </MovableModalContainer>
  )
}
